import { venueMarkNotificationsReceived } from '../../graphql/mutations';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueMarkNotificationsReceivedApi = async (venueID: string): Promise<string> => {
  const result = await executeGql<string>(venueMarkNotificationsReceived, { venueID });
  return processGqlResult<string>('venueMarkNotificationsReceived', result);
};
